module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/reviewed-6ef49359435b85c6266e6b050690ecec.png";